<div class="data-table-container" [ngStyle]="{ height: height, 'max-height': maxHeight, width: width, 'max-width': maxWidth, overflow: overflow, 'min-width': !overflow ? 'min-content' : undefined }">
    <table mat-table matSort [dataSource]="rows" class="data-table" [ngStyle]="{ 'table-layout': layoutMode, 'min-width': minWidth }" (matSortChange)="onSortChange($event)">
        <!-- Definición de la columna de checkboxes -->
        <ng-container matColumnDef="checkboxes-column" *ngIf="selectionType === 'multiple'">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox [checked]="allSelected()" (change)="selectAllChange($event)" color="primary"></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row; let rowIndex = index;" [ngStyle]="{ width: '60px' }">
                <mat-checkbox [checked]="isSelected(row)" (change)="updateSelection(row, $event)" color="primary"></mat-checkbox>
            </td>
        </ng-container>
        <!-- Definición de columna genérica -->
        <ng-container matColumnDef="{{columnIndex}}" *ngFor="let column of columns; let columnIndex = index">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!column.sortable" [ngClass]="{ sortable: !!column.sortable }">
                {{ column.name ? column.name : '' }}
            </th>
            <td mat-cell *matCellDef="let row; let rowIndex = index;" class="{{column.cellClass ? column.cellClass : ''}}" [ngStyle]="{ width: column.width ? column.width : '', 'min-width': column.minWidth ? column.minWidth : '', 'max-width': column.maxWidth ? column.maxWidth : '' }">
                <div class="cell-content" [innerHTML]="getCellContent(row, rowIndex, column)" *ngIf="!column.template"></div>
                <div class="cell-content" *ngIf="column.template">
                    <ng-container [ngTemplateOutlet]="column.template" [ngTemplateOutletContext]="{ rowIndex: rowIndex, value: getCellContent(row, rowIndex, column), row: row, column: column, params: column.templateParams }"></ng-container>
                </div>
            </td>
        </ng-container>
        <!-- Definición de la columna de botones -->
        <ng-container matColumnDef="buttons-column" *ngIf="menuButtons?.length">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row; let rowIndex = index;" [ngStyle]="{ width: menuButtons.length === 1 ? '130px' : '60px' }">
                <button mat-raised-button class="garantor-button mini menu-single-button" color="primary" (click)="menuButtons[0].action(row)" *ngIf="menuButtons.length === 1" [disabled]="menuButtons[0].isDisabled ? menuButtons[0].isDisabled(row) : false">
                    {{ menuButtons[0].label }}
                </button>
                <button mat-icon-button [matMenuTriggerFor]="menu" (click)="activeMenuRow = row" *ngIf="menuButtons.length > 1">
                    <mat-icon> more_vert </mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="getColumnsToShow(); sticky: !!stickyHeader" [ngStyle]="{ 'background-color': stickyHeader && stickyHeaderBackground ? stickyHeaderBackground : 'transparent' }"></tr>
        <tr mat-row *matRowDef="let row; columns: getColumnsToShow();" [ngClass]="{ selected: isSelected(row), selectable: selectionType === 'single' }" (click)="handleRowClick(row, $event)"></tr>
    </table>
    <div class="empty-message" *ngIf="!rows?.length">
        {{ rows === undefined || rows === null ? 'Consultando...' : 'Sin datos' }}
    </div>
    <mat-paginator
        class="data-table-paginator"
        [length]="paginatorStatus.totalElementCount"
        [pageSize]="paginatorStatus.itemsPerPage"
        [pageSizeOptions]="[5, 25, 50, 100]"
        [pageIndex]="paginatorStatus.page"
        (page)="callUpdateRows($event)"
        *ngIf="paginatorStatus"
    ></mat-paginator>
    <mat-menu #menu="matMenu" class="data-table-menu">
        <button mat-menu-item *ngFor="let button of menuButtons" (click)="button.action(activeMenuRow)" [disabled]="button.isDisabled ? button.isDisabled(activeMenuRow) : false">
            {{ button.label }}
        </button>
    </mat-menu>
</div>

